// isolate each business logic for SKWK

import { useAppSelector } from 'dux/app/hooks';

import { couponCodes } from 'Services/CouponService';

import { getIsAuthenticated } from 'dux/auth/selectors';
import {
  getCouponsStatuses,
  getIsLoading as getIsCouponsStatusLoading,
} from 'dux/couponsStatuses/selectors';
import {
  shouldShowEvergreenWelcomeKit,
  shouldShowWelcomeKitVisibility,
} from 'dux/featureFlags/selectors';
import { getHasActiveHaircareSubscription, getHasOrdersByCategory } from 'dux/user/selectors';

const beforeEvergreenWelcomeKit = ({
  isAuthenticated,
  isCouponsStatusLoading,
  couponsStatuses,
  showWelcomeKitVisibility,
}) => {
  const isOfferAvailable = couponsStatuses?.coupons?.some(
    c =>
      c.code === couponCodes.skincareWelcomeKit &&
      c.is_attached_to_customer &&
      c.status === 'created'
  );
  if (showWelcomeKitVisibility && isAuthenticated && !isCouponsStatusLoading) {
    return isOfferAvailable;
  }
  return false;
};

const afterEvergreenWelcomeKit = ({
  showWelcomeKitVisibility,
  isAuthenticated,
  hasSkincareOrder,
  hasHaircareSubscription,
  isCouponsStatusLoading,
  couponsStatuses,
}) => {
  const isOfferAvailable = couponsStatuses?.coupons?.some(
    c =>
      c.code === couponCodes.skincareWelcomeKit &&
      c.is_attached_to_customer &&
      c.status === 'created'
  );
  return (
    showWelcomeKitVisibility &&
    isAuthenticated &&
    hasHaircareSubscription &&
    !hasSkincareOrder &&
    !isCouponsStatusLoading &&
    isOfferAvailable
  );
};

const promoConditions = {
  skincareWelcomeKit: promoContext =>
    promoContext.showEvergreenWelcomeKit
      ? afterEvergreenWelcomeKit(promoContext)
      : beforeEvergreenWelcomeKit(promoContext),
};

const usePromoContext = () => {
  const isAuthenticated = useAppSelector(getIsAuthenticated);

  const isCouponsStatusLoading = useAppSelector(getIsCouponsStatusLoading);
  const couponsStatuses = useAppSelector(getCouponsStatuses);

  const hasHaircareSubscription = useAppSelector(getHasActiveHaircareSubscription);
  const hasSkincareOrder = useAppSelector(state => getHasOrdersByCategory(state).skincare);

  /* @ts-expect-error - featureFlags selectors to be typed */
  const showWelcomeKitVisibility = useAppSelector(shouldShowWelcomeKitVisibility); // "exclusive" offer (for pre-selected customers)
  /* @ts-expect-error - featureFlags selectors to be typed */
  const showEvergreenWelcomeKit = useAppSelector(shouldShowEvergreenWelcomeKit); // "unrestricted" offer (for all customers)

  return {
    isAuthenticated,
    isCouponsStatusLoading,
    couponsStatuses,
    hasHaircareSubscription,
    hasSkincareOrder,
    showWelcomeKitVisibility,
    showEvergreenWelcomeKit,
  };
};

export const useSkincareWelcomeKitOffer = () => {
  const promoContext = usePromoContext();
  return promoConditions.skincareWelcomeKit(promoContext); // currently return bool, but later on should return identifier
};

// TODO?
// const globalPriorityList = [];

// TODO?
// const promoIdentifiers = ['skincare_welcome'];
// const [] = usePromoIdentifiers()
